import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import httpRequest from './utils/httpRequest'
import API from './api'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'

Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.config.productionTip = false
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$api = API
document.title = "陕西陕煤检测科技有限公司"
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
